<template>
<div class="widthFull" id="site-nav">

  <div class="container widthFull">
  <div class="row">
    <div class="col-6 col-md-6 pt-1 pb-1">
      <ul class="navbar-nav m-auto mb-lg-0 mb-md-5">

        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
          <router-link class="nav-link" v-scroll-to="'.main'" to="/" data-toggle="collapse" data-target=".navbar-collapse.show">
            <span class="menuItem Bold"> <b v-if="brand == 'CHEBONUS'" class="Bold">CheBonus</b> <b v-if="brand == 'HAPPYBONUS'" class="Bold">HappyBonus</b> </span>
          </router-link>
        </li>

      </ul>
    </div>
    <div class="col-6 col-md-6 pt-1 pb-1">
      <ul class="navbar-nav d-block  mb-lg-0 mb-md-5 text-right ">

      <li v-if="isProfileLoaded" class="nav-item dropdown mr-0 pd-0 custNavWidth float-right">
        <a class="nav-link dropdown-toggle menuItem mr-0 pd-0" href="#" id="navbardrop" data-toggle="dropdown">
          <font-awesome-icon class="pointer mr-0 pd-0" icon="user" size="1x" />
          <!-- {{getProfile.name}} {{getProfile.lastname}} --> <template v-if="vw > 500"> Gestione </template> Profilo <template v-if="vw > 500">aderente</template> e FAQ
        </a>
        <div class="dropdown-menu bgDrop" data-toggle="collapse " data-target=".navbar-collapse.show">

          <router-link class="dropdown-item menuItem " to="/account" v-scroll-to="'.main'" data-toggle="collapse" data-target=".navbar-collapse.show">
            <span class="menuItem ipadMenu">Modifica Profilo aderente</span>
          </router-link>
          <!--
          <router-link class="dropdown-item menuItem " to="/faq" v-scroll-to="'.main'" data-toggle="collapse" data-target=".navbar-collapse.show">
            <span class="menuItem ipadMenu">Guida all'utilizzo e FAQ</span>
          </router-link>
        -->
          <a class="dropdown-item pointer menuItem black" @click="logout"><span class="menuItem ipadMenu">Esci</span></a>
        </div>
      </li>



      <li v-if="!isProfileLoaded" class="nav-item " data-toggle="collapse" data-target=".navbar-collapse.show">
        <router-link class="nav-link" to="/login">
          <span class="menuItem ">Registrati/Accedi</span>
        </router-link>
      </li>
    </ul>
    </div>
  </div>
  </div>

  <nav v-show="!menuOFF" class="navbar navbar-light  navbar-expand-lg bgWhite " style="z-index: 11" :class="{'fixed-top' :  scroll > 48 }">
    <div class="container widthFull center">


          <div class="navbar-header ">

            <router-link to="/"  class="navbar-brand router-link-exact-active router-link-active">
              <img v-if="brand == 'CHEBONUS'" src="../../assets/images/vaillant-logo.png" alt="" class="img-fluid logo ml-0" ref="mainNavLogo">
              <img v-if="brand == 'HAPPYBONUS'" src="../../assets/images/hsd-logo.png" alt="" class="img-fluid logo ml-0" ref="mainNavLogo">
            </router-link>

            <button type="button" class="  navbar-toggler navbar-toggler-right align-self-center navbar-toggle collapsed" :class="{'btnBurgrHSDRed': brand == 'HAPPYBONUS' }" data-toggle="collapse" data-target="#navbarCollapse" aria-expanded="false">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar top-bar"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>

          </div>


          <div class="collapse navbar-collapse flex-column ml-0 pl-3" id="navbarCollapse">

            <ul class="navbar-nav mr-auto mb-lg-0 mb-5">

              <!-- LOGED IN  MENU *************************************************************** -->

              <li v-if="isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/flowSettings'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">
                    Gestione Prerequisiti Cessione
                    <template v-if="getProfile.cdp_expired_at">
                      <span v-if="moment().add(10, 'days') > moment(getProfile.cdp_expired_at)" class="badge badge-danger">!</span>
                    </template>
                  </span>
                </router-link>
              </li>

              <li v-if="isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/calcolatore'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">Crea nuovo Preventivo</span>
                </router-link>
              </li>

              <li v-if="isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/offerte'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">Gestione Preventivi</span>
                </router-link>
              </li>

              <li v-if="isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/pratiche'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">Gestione Pratiche</span>
                </router-link>
              </li>

              <li v-if="isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/cessioni'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">Gestione Cessioni</span>
                </router-link>
              </li>





              <!-- END LOGED IN  MENU *************************************************************** -->

              <!-- NO LOGED  MENU *************************************************************** -->

              <li v-if="!isProfileLoaded" class="nav-item" >
                <a v-if="brand == 'CHEBONUS'" class="nav-link" href="https://www.vaillant.it/professionisti/prodotti/che-bonus/" target="_blank" >
                  <span class="menuItem Bold">Scopri CheBonus</span>
                </a>
                <a v-if="brand == 'HAPPYBONUS'" class="nav-link" href="https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/" target="_blank" >
                  <span class="menuItem Bold">Scopri HappyBonus</span>
                </a>

              </li>

              <li v-if="!isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/cessioni'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">Area riservata aderente</span>
                </router-link>
              </li>

              <li v-if="!isProfileLoaded" class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                <router-link class="nav-link" :to="{ path: '/registration'}" data-toggle="collapse" data-target=".navbar-collapse.show">
                  <span class="menuItem Bold">Registrati</span>
                </router-link>
              </li>

              <!-- END NO LOGED  MENU *************************************************************** -->

            </ul>

          </div>



          <div class="notificationContent" :class="{'notificationC': showNotification}">
            <div class="container relative pb-5 maxNotification">

              <div class="row justify-content-center widthFull">
                <div class="col-md-4 pl-5 pb-2">
                  <h2 class="black widthFull pb-0 mb-1">
                    <b class="widthFull">Notifiche</b>
                  </h2>
                  <p class="widthFull"></p>
                </div>

                <div class="col-md-8 pl-5 pb-2 pt-4 pb-4 reverse">
                  <div v-for="(item, index) in notifications" class="row justify-content-center widthFull ">
                    <div class="col-md-11 pl-5 mb-2" :class="{'errorBg': item.type == 'ERROR', 'successBg': item.type == 'SUCCESS' }">
                      {{parseInt(index)+1}}) <span v-html="item.text"></span>
                    </div>
                  </div>

                  <div v-if="countNotification == 0" class="row justify-content-center widthFull">
                    <div class="col-md-12 center pl-5 ">
                      <h5 class=""><b>Non hai nessuna notifica</b></h5>
                    </div>
                  </div>

                </div>
              </div>



            </div>
          </div>



    </div>

  </nav>

  <div class="container-fluid">
    <!--
			<img v-if="vw > 500"  v-bind:style="opacity" v-observe-visibility="{ callback: visibilityChanged, intersection: { rootMargin: '-190px' } }" class="img-fluid scrollLogo" style="min-width: 100%;" src="../../assets/images/logo.png">
			<img v-else  v-bind:style="opacity" v-observe-visibility="{ callback: visibilityChanged, intersection: { rootMargin: '-90px' } }" class="img-fluid scrollLogo" style="min-width: 100%;" src="../../assets/images/logo.png">
		-->
  </div>






  <!-- NOTIFICATIONS LABEL
  <div v-show="!menuOFF" v-if="vw > 767" class="sidetab2" v-click-outside="outside3">
    <div class="label" v-on:click="toggleNotification">
      <img v-if="vw < 533" class="img-fluid contactImg" src="../../assets/images/contact2.png">
      <span v-else>
        <img class="leftIm2" src="../../assets/images/notifications.png">
        Notifiche <span v-if="countNotification">{{countNotification}}</span>
      </span>
    </div>
  </div>-->


  <!-- CALL CENTERRRRRR -->
  <div v-show="!menuOFF" v-if="vw > 767 && isProfileLoaded" class="sidetab"  v-click-outside="outside2" :class="{'sidebar-opened': toggleTabState == 'open', 'sidebar-closed': toggleTabState == 'close', 'tabMobile': vw < 533, 'sidetabHSD': brand == 'HAPPYBONUS'  }">
    <div class="label" v-on:click="toggleTab">
      <!--<font-awesome-icon class="zoomImage fa-2x" icon="question-circle" size="lg" />-->

      <img v-if="vw < 533" class="img-fluid contactImg" src="../../assets/images/contact2.png">

      <span v-else>
        <img class="leftIm" :class="{ 'posWA': toggleTabState != 'close'  }" src="../../assets/images/wa.png">
        Per assistenza
        <img class="rightIm" :class="{ 'posTEL': toggleTabState != 'close'  }" src="../../assets/images/tel.png">
      </span>

    </div>
    <div class="content">
      <div class="inner-content">
        <div class="content-message"><strong>Hai bisogno di assistenza?</strong></div>
        <div class="media chat-available voice-available video-available">


          <div class="media-label" style="padding-top: 5px;font-size: 12px; font-weight: bold; color: rgba(0, 0, 0, 0.54);">

            Chiama il numero <span class="black" v-html=" brand == 'CHEBONUS' ? phone : phone_hsd "></span>
            <!--02 9475 1001 HSD-->
            <br />o invia WhatsApp a <span class="green" :class="{'redHSD': brand == 'HAPPYBONUS' }" ><b v-html=" brand == 'CHEBONUS' ? phone : phone_hsd "></b></span>
            <!--02 9475 1001 HSD-->


            <br />oppure scrivi a:
            <br /><a :href="'mailto:' + (brand == 'CHEBONUS' ? email : email_hsd)" class="black" v-html=" brand == 'CHEBONUS' ? email : email_hsd "></a> <!-- info@happybonus.it HSD-->
            <br />dal lunedì al venerdì
            <br />dalle 09:00-13:00 e 14:00-18:00
            <br />esclusi i giorni festivi
            <br /><br />

          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="container-fluid fixed cookieBaner" :class="{'redHSDBack': brand == 'HAPPYBONUS' }" v-if="!acceptCookies">
    <div class="row justify-content-center widthFull">
      <div class="col-12 col-sm-10 col-md-9 col-lg-6 pt-sm-0 pt-md-3">
        <span class="cookieText">
          Utilizziamo i cookie al fine di personalizzare e migliorare la tua esperienza sul nostro sito.
          Visita la nostra <a style="color: #f39324!important; text-decoration: underline" target="_blank" href="informativa.pdf">informativa</a> per acquisire maggiori informazioni.
          Utilizzando il nostro sito accetti l'utilizzo dei cookie da parte nostra.
        </span>
      </div>

      <div class="col-12 col-sm-2 center col-md-2 col-lg-2 mt-sm-5 pt-3 pt-md-2 mt-md-3">
        <button class="btn btn-primary btn-lg yellowBtn mb-5 pr-3 pl-3" :class="{'btnYellow': brand == 'HAPPYBONUS' }" v-on:click="doAcceptCookies"> OK</button>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import {
  AUTH_LOGOUT
} from 'actions/auth'
import {
  ACCEPT_COOKIES
} from 'actions/user'
import {
  ADD_NOTIFICATIONS,
  GET_NOTIFICATIONS
} from 'actions/notifications'

import axios from 'axios'

const moment = require('moment')

export default {
  name: 'navigation',
  components: {

  },
  data() {
    return {
      moment: require('moment'),
      scroll: 0,
      toggleTabState: 'close',
      vw: window.innerWidth,
      notifications: {},
      countNotification: 0,
      showNotification: false,
      menuOFF: false,
      brand: process.env.BRAND,
      phone: process.env.CONTACT_PHONE,
      email: process.env.CONTACT_EMAIL,
      phone_hsd: process.env.CONTACT_PHONE_HSD,
      email_hsd: process.env.CONTACT_EMAIL_HSD,
    }
  },

  methods: {
    handleResize: function() {
      this.vw = window.innerWidth
    },
    toggleTab() {
      console.log(this.toggleTabState)
      if (this.toggleTabState == 'close') {
        this.toggleTabState = 'open'
      } else {
        this.toggleTabState = 'close'
      }
    },

    toggleNotification() {
      if (this.showNotification) {
        this.showNotification = false
      } else {
        this.showNotification = true
      }
    },
    updateScroll: function() {
      this.scroll = window.pageYOffset
    },
    outside2: function(e) {
      if (this.toggleTabState == 'open') {
        this.toggleTabState = 'close'
      }
    },
    outside3: function(e) {
      if (this.showNotification) {
        this.showNotification = false
      }
    },
    doAcceptCookies: function() {

      this.$store.dispatch(ACCEPT_COOKIES).then((resp) => {
        //this.$router.push('/')
      })

    },
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    },
    handleResize: function() {
      this.vw = window.innerWidth
    },

    checkForfettario: function() {

      if (this.getProfile) {

        if ((this.getProfile.tipo_azienda == "Ditta Individuale" || this.getProfile.tipo_azienda == "Professionista iscritto ad albi") && this.getProfile.reg_forfettario == '0') {

          this.$swal({
            type: 'warning',
            title: 'Attenzione!',
            text: 'Indica nell`apposito form se rientri o meno nel Regime Forfettario e clicca sul pulsante SALVA.',
          });

          this.$router.push('/account')

        }

      }

    },
    checkSoftwareVersion(){
      console.log( 'CHECK VERSION SW ************' )
      var version = localStorage.getItem('sw_version')

      if( !version ){
        console.log( 'VERSION NOT SAVED => ' + version )
        version = false
      }else{
        console.log( 'ACTUAL VERSION => ' + version )
      }

      axios({
          url: process.env.ROOT_API + 'api/checkSoftwareVersion',
          method: 'POST',
          data: {
            version: version,
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {

          if( resp.data.version ){
            console.log( 'SERVER VERSION => ' + resp.data.version )
            if( version != resp.data.version ){
              localStorage.setItem('sw_version', resp.data.version)
              window.location.reload()
            }
          }

        })
        .catch(error => {

        })

    },
    checkNews: function() {

      var hasSeeNews = localStorage.getItem('news5')

      if (this.isAuthenticated) {
        //var html = 'Siamo felici di segnalarti che sono stati attivati sulla CHEBONUS Suite i servizi opzionali <br/>per la compilazione e l`invio telematico della <b class="Bold ">pratica ENEA</b> <br/>e per l`estrazione della <b>Visura Catastale</b>.'
        //var html = 'A causa di un`anomalia sulla rete telefonica nazionale il numero del contact center risulta momentaneamente non raggiungibile. <br/> Rimaniamo a vostra disposizione sull`indirizzo email info@chebonus.it'

        //html += '<h2 class="white">Attenzione!</h2>L’aliquota degli oneri di attualizzazione dei crediti d’imposta di Poste Italiane relativi a Bonus Casa 50%, Ecobonus 50%, Ecobonus 65% e Superbonus 110% indicata nei Preventivatore di CheBonus è puramente indicativa ed estratta il giorno precedente all’elaborazione del Preventivo dal simulatore di cessione del credito di Poste Italiane.'
        //html += 'Prima di confermare il preventivo su CheBonus, sottoporlo al tuo cliente ed emettere fattura allo stesso, ti invitiamo a verificare sempre l’aliquota aggiornata degli oneri di attualizzazione dei crediti d’imposta di Poste Italiane relativi a Bonus Casa 50%, Ecobonus 50%, Ecobonus 65% e Superbonus 110%  sul Simulatore di cessione dei crediti d’imposta di Poste Italiane disponibile al seguente <a target="_blank" href="https://cessionecrediti.poste.it/simulatore/index.html?wt.ac=1476524448679">LINK</a> <br/>'
        //html += 'Novatag, Vaillant Group Italia, Società di Consulenza per gli adempimenti connessi alle agevolazioni fiscali previste alla fornitura del servizio CheBonus non si ritengono responsabili per eventuali danni economici derivanti dall’omissione della verifica dell’aliquota aggiornata degli oneri di attualizzazione dei crediti d’imposta di Poste Italiane da parte dell’installatore o altre Società aderenti a CheBonus'

        var html = ''
        html += '<h5 class="text-left white">Nuove funzionalità del preventivatore per il calcolo dell`IVA<br/></h5>'

        html += '<h3 class="center white"> Avviso! </h3> '

        html += '<h5 class="center white"> Nuovo tasso di cessione Poste Italiane vs Ecobonus 65%-50% e Bonus Casa 50% </h5> '
        html += '<p class="text-left">Gentile professionista,<br/>'
        html += 'Poste Italiane ha da poco comunicato sul suo sito web che a partire dal <b>28 maggio 2021</b> i prezzi di acquisto del credito d’imposta per i bonus ripartiti in 10 quote annuali saranno oggetto di revisione.<br/>'
        html += 'Il comunicato di Poste Italiane è disponibile al seguente  <a target="_blank" href="https://business.poste.it/professionisti-imprese/prodotti/cessione-dei-crediti-di-imposta.html">link </a> <br/><br/>'
        html += 'Il Preventivatore è stato aggiornamento con il nuovo tasso di cessione dei relativi bonus che sarà applicato da Poste Italiane a partire dal 28 maggio 2021.<br/>'
        html += 'Per ogni tua richiesta non esitare a contattarci al numero tel. 02.94756.677, sempre disponibili dal lunedì al venerdì negli orari 09:00-13:00 e 14:00-18:00, oppure inviaci una mail a info@chebonus.it<br/>'

        html += 'Ringraziandoti per aver scelto di installare i nostri prodotti, <a target="_blank" href="https://www.vaillant.it/home/"> Vaillant </a> ti augura una serena giornata e Buon lavoro!<br/><br/>'
        html += 'Il tuo team Vaillant CheBonus!<br/></p>'

        alert.text = html
        alert.type = 'SUCCESS'
        this.$store.dispatch(ADD_NOTIFICATIONS, alert)
      }

      if (3 == 4 && !hasSeeNews && this.isAuthenticated) {
        localStorage.setItem('news5', 'type1')

        this.$swal({
          type: 'info',
          title: 'Novità',
          //title: 'AVVISO',
          html: html,
        });

      }


    }


  },
  watch: {
    $route (to, from){
        this.checkSoftwareVersion();
    },
    getProfile() {
      this.checkForfettario()
    },
    isAuthenticated() {
      this.checkNews()
    },
    'getNotifications': function() {
      this.notifications = this.getNotifications
      this.countNotification = this.getNotificationsCount

      // CHECK MENU OFF
      for (var x in this.notifications) {
        if (this.notifications[x].type == 'MENU_OFF') {
          this.menuOFF = true
        }
      }

      var _vue = this
      setTimeout(function() {
        //_vue.showNotification = true
      }, 200)
      setTimeout(function() {
        //_vue.showNotification = false
      }, 12000)

    },
  },
  computed: {
    ...mapGetters(['getNotifications', 'getNotificationsCount', 'getProfile', 'isAuthenticated', 'isProfileLoaded', 'acceptCookies', 'checkAge']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      name: state => `${state.user.profile.name}`
      //notifications: state => `${state.notifications}`,

    })
  },
  updated() {

  },
  mounted() {
    var _vue = this
    this.checkNews()
    window.addEventListener('scroll', this.updateScroll);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.checkForfettario()
  },
  directives: {
    'click-outside': {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}
</script>

<style lang="css" scoped>

.redHSDBack{
  background: #d40c2d;
}

.custNavWidth{

  max-width: 240px;

}

.contactImg {
    width: 47px;
    transform: rotate(62deg);
}
.sidebar-opened {
	right: 0;
	animation: open;
	animation-duration: 0.5s;
	animation-timing-function: ease;
}

.dropdown-toggle{
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}

.sidetab > .label {
    cursor: pointer;
    border: 1px solid #9898ab;
    font-size: 17px!important;
    padding-top: 15px!important;
		color: #fdfdfd;
		height: 60px;
		font-size: 21px;
		font-weight: bold;
		background: #00917e;
    text-transform: uppercase;
    text-align: center;
    padding-top: 3px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 8px #262626;
    box-shadow: 0 0 8px #262626;
}


.sidebar-opened > .label > .contactImg{
	opacity: 0;
}

.tabMobile > .label{
	background: transparent;
	padding-top: 0px!important;
}

.sidebar-opened > .label{
	background-color: #101417;
	height: 48px;
	color: transparent;
}



.content {
    height: 240px;
    padding-left: 39px;
    padding-top: 31px;
}

.content {
    background-color: #F2F2F2;
    box-sizing: border-box;
    padding-bottom: 10px;
}

.sidebar-closed {
    animation: close;
    animation-duration: 0.5s;
    animation-timing-function: ease;
}

.sidetab {
    width: 256px;
    height: 280px;
		border-top-left-radius: 50%;
		border-top-right-radius: 50%;
    left: auto;
    top: 75%;
    margin-top: -185px;
    bottom: auto;
    border-radius: 10px 10px 0 0;
    transform: rotate(-90deg);
		z-index: 2147483647;
    box-sizing: border-box;

    position: fixed;
		letter-spacing: 0px !important;
}





.sidetab2 {
	border-top-left-radius: 50%;
	border-top-right-radius: 50%;
    right: -223px;
    animation: reveal;
    animation-duration: 0.5s;
    animation-timing-function: ease;
}

.sidetab2 {
	width: 187px;
	height: 280px;
		border-top-left-radius: 50%;
		border-top-right-radius: 50%;
    left: auto;
    top: 25%;
    margin-top: -15px;
    bottom: auto;
    border-radius: 10px 10px 0 0;
    transform: rotate(-90deg);
		z-index: 2147483647;
    box-sizing: border-box;

    position: fixed;
		letter-spacing: 0px !important;
}
.sidetab {
	border-top-left-radius: 50%;
	border-top-right-radius: 50%;
    right: -223px;
    animation: reveal;
    animation-duration: 0.5s;
    animation-timing-function: ease;
}

.sidetab2 {
	border-top-left-radius: 50%;
	border-top-right-radius: 50%;
    right: -188px;
    animation: reveal;
    animation-duration: 0.5s;
    animation-timing-function: ease;
}

.sidetab2 > .label {
    cursor: pointer;
    border: 1px solid #9898ab;
    font-size: 17px!important;
    padding-top: 15px!important;
		color: #fdfdfd;
		height: 60px;
		font-size: 21px;
		font-weight: bold;
		background: #f39324;
    text-transform: uppercase;
    text-align: center;
    padding-top: 3px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 8px #262626;
    box-shadow: 0 0 8px #262626;
}

.sidetab2.container .content {
    background-color: #F2F2F2;
    box-sizing: border-box;
    padding-bottom: 10px;
}
.sidetab2.sidebar-opened {
    right: 0!important;
    animation: open;
    animation-duration: 0.5s;
    animation-timing-function: ease;
}

.media-label {
    padding: 4px 8px;
}
.inner-content {
    transform: rotate(90deg);
		height: 173px;
}

.media {
    width: 215px;
}

.content-message {
    color: rgba(0,0,0,0.54);
    font-size: 14px;
    font-weight: 900;
    text-transform: uppercase;
    text-align: center;
    padding: 10px 0;
		width: 200px;
}
.content-message {
    padding: 8px 10px;
}
.sidetab.container .content {
    background-color: #F2F2F2;
    box-sizing: border-box;
    padding-bottom: 10px;
}
.sidetab.sidebar-opened {
    right: 0!important;
    animation: open;
    animation-duration: 0.5s;
    animation-timing-function: ease;
}
.fa-question-circle {
    transform: rotate(90deg);
		color: #e3000f;
background: azure;
border-radius: 50%;
}

@media (min-width: 20px) and (max-width: 499px) {
  .cookieText{
    font-size: 14px;
  }

  .cookieBaner {

    height: 350px;
  }

  .notificationContent {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 65px;
    background: #eeeeee;
    width: 100%;
    overflow: hidden;
    transition: .3s ease !important;
    height: 0px;
    border-bottom: 10px solid white;
}


}

@media (min-width: 500px) and (max-width: 768px) {
  .cookieText{
    font-size: 18px;
  }

  .cookieBaner {

    height: 250px;
  }

  .notificationContent {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 65px;
    background: #ffd8ab;
    width: 100%;
    overflow: hidden;
    transition: .3s ease !important;
    height: 0px;
    border-bottom: 10px solid white;
}

}

@media (min-width: 769px) and (max-width: 1550px) {

.cookieText{
  font-size: 15px;
}





}


#site-nav .navbar-toggler {

}

#site-nav .navbar-toggler {
  border: none!important;
  background: transparent !important;
}
#site-nav .navbar-toggler .icon-bar {
  width: 22px;
  -webkit-transition: all 0.2s!important;
  transition: all 0.2s!important;
  width: 30px!important;
  height: 3px!important;
  display: block;
  margin: 5px;
}
#site-nav .navbar-toggler .top-bar {
  transform: rotate(45deg);
  transform-origin: 10% 10%!important;
}
#site-nav .navbar-toggler .middle-bar {
  opacity: 0!important;
}
#site-nav .navbar-toggler .bottom-bar {
  transform: rotate(-45deg);
  transform-origin: 10% 90%!important;
}
#site-nav .navbar-toggler.collapsed .top-bar {
  transform: rotate(0)!important;
}
#site-nav .navbar-toggler.collapsed .middle-bar {
  opacity: 1!important;
}
#site-nav .navbar-toggler.collapsed .bottom-bar {
  transform: rotate(0)!important;
}
.navbar-toggler .icon-bar {
    background-color: #00897e!important;
}


.navbar-toggler {
  padding: .25rem .75rem;
  font-size: 1.25rem;
  line-height: 15;
  background-color: white;
  border: 1px solid transparent;
  border-radius: .25rem;

  margin-top: 10px;
}

.btnBurgrHSDRed > .icon-bar{
    background-color: #c03!important;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/index.vue